import styled from 'styled-components';
import interactionIcon from 'assets/logo/interaction.svg';

export const InteractionIcon = styled.div`
  padding: 10px;
  margin-bottom: -5px;
  background-image: url(${interactionIcon});
`;
